/* eslint-disable no-redeclare */

const key = (function (b, v) {
  var m = b.length
  var q = []
  for (var e = 0; e < m; e++) {
    q[e] = b.charAt(e)
  }
  for (var e = 0; e < m; e++) {
    var h = v * (e + 292) + (v % 21545)
    var i = v * (e + 748) + (v % 42911)
    var o = h % m
    var g = i % m
    var t = q[o]
    q[o] = q[g]
    q[g] = t
    v = (h + i) % 7515954
  }
  var c = String.fromCharCode(127)
  var l = ''
  var a = '\x25'
  var z = '\x23\x31'
  var p = '\x25'
  var u = '\x23\x30'
  var j = '\x23'
  return q
    .join(l)
    .split(a)
    .join(c)
    .split(z)
    .join(p)
    .split(u)
    .join(j)
    .split(c)
})('9OInoRfTeRJfoQb', 7298171)
export default key
